/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { JumboGetaccountdetailsAccountDetail } from './JumboGetaccountdetailsAccountDetail';
import {
    JumboGetaccountdetailsAccountDetailFromJSON,
    JumboGetaccountdetailsAccountDetailFromJSONTyped,
    JumboGetaccountdetailsAccountDetailToJSON,
} from './JumboGetaccountdetailsAccountDetail';

/**
 * 
 * @export
 * @interface JumboGetaccountdetailsGetAccountDetailsResult
 */
export interface JumboGetaccountdetailsGetAccountDetailsResult {
    /**
     * 
     * @type {Array<JumboGetaccountdetailsAccountDetail>}
     * @memberof JumboGetaccountdetailsGetAccountDetailsResult
     */
    accounts?: Array<JumboGetaccountdetailsAccountDetail>;
}

/**
 * Check if a given object implements the JumboGetaccountdetailsGetAccountDetailsResult interface.
 */
export function instanceOfJumboGetaccountdetailsGetAccountDetailsResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function JumboGetaccountdetailsGetAccountDetailsResultFromJSON(json: any): JumboGetaccountdetailsGetAccountDetailsResult {
    return JumboGetaccountdetailsGetAccountDetailsResultFromJSONTyped(json, false);
}

export function JumboGetaccountdetailsGetAccountDetailsResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboGetaccountdetailsGetAccountDetailsResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'accounts': !exists(json, 'accounts') ? undefined : ((json['accounts'] as Array<any>).map(JumboGetaccountdetailsAccountDetailFromJSON)),
    };
}

export function JumboGetaccountdetailsGetAccountDetailsResultToJSON(value?: JumboGetaccountdetailsGetAccountDetailsResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'accounts': value.accounts === undefined ? undefined : ((value.accounts as Array<any>).map(JumboGetaccountdetailsAccountDetailToJSON)),
    };
}

